import type { PropsWithChildren } from 'react';
import type { SuccessGamblingProps } from '@/components/success-gambling/success-gambling.types';
import { useReducer } from 'react';
import { convertCompanyNamesToCompany, convertCompanyNamesToTips } from '@/components/success-gambling/utils/functions';
import { SuccessGamblingContext } from '@/components/success-gambling/context';

export default function SuccessGamblingProvider(props: PropsWithChildren<SuccessGamblingProps>) {
  const { answers, questions, fullName, email, children } = props;
  const [state] = useReducer(
    (state) => state,
    {
      answers,
      questions,
      fullName,
      email,
    },
    ({ answers, questions, fullName }) => ({
      answers,
      company: convertCompanyNamesToCompany(answers, fullName, email),
      tips: convertCompanyNamesToTips(answers, questions, fullName),
    }),
  );

  return <SuccessGamblingContext.Provider value={{ ...state }}>{children}</SuccessGamblingContext.Provider>;
}
